import * as React from 'react';

const TOKEN = /(https?:\/\/[^\s)]+|[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}|\/[a-z0-9]+(?:\/[a-z0-9\-]+)*)/gi;

export function LinkedText({ text }: { text: string }) {
  const nodes: React.ReactNode[] = [];
  const re = new RegExp(TOKEN);
  let last = 0;
  let match: RegExpExecArray | null;

  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      nodes.push(text.slice(last, match.index));
    }

    const raw = match[0];
    const href = raw.includes('@') && !raw.startsWith('http') ? `mailto:${raw}` : raw;
    nodes.push(
      <a key={`${match.index}-${raw}`} href={href} className="whyus-inline-link">
        {raw}
      </a>
    );
    last = match.index + raw.length;
  }

  if (last < text.length) {
    nodes.push(text.slice(last));
  }

  return (
    <>
      <style>{`
        .whyus-inline-link {
          color: #1EAA25;
          font-weight: 600;
          text-decoration: underline;
          word-break: break-word;
        }
        .whyus-inline-link:hover {
          color: #178f1e;
        }
      `}</style>
      {nodes}
    </>
  );
}
